import { atom } from 'jotai';

const userSampleData = {
  name: '',
  role: '',
  access: {},
};

const getInitialScope = () => {
  const scopeItem = localStorage.getItem('scope');
  if (scopeItem) {
    try {
      return JSON.parse(scopeItem);
    } catch {
      return userSampleData;
    }
  }
  return userSampleData;
};

// Primitive writable atom with localStorage initialization
export const userScopeAtom = atom(getInitialScope());
